<template>
    <div class="d-flex align-items-center cursor-pointer">
        <the-btn @click.native="onClick" class="btn-primary btn-sm">
            <span class="d-lg-none mr-1">Edytuj</span>
            <a-icon style="color: white" :icon="'Edit'" />
        </the-btn>
    </div>
</template>

<script>
export default {
    name: 'UserStoresTableEditBtn',
    props: {
        onClick: {
            type: Function,
            default: () => {}
        }
    }
}
</script>
